import React from "react"
import Banner from '../components/Banner/Banner';
import ImageGrid from '../components/ImageGrid/ImageGrid'; 

const SearchResultsPage = () => {
    return (
        <>
          <Banner/> 
          <ImageGrid/>
        </>
    )
}

export default SearchResultsPage;
